/**
 * Turns the string an <input> hands back into a number we are willing to send to the API.
 *
 * Number() is too permissive for money: "" becomes 0, "  " becomes 0, and "1e999"
 * becomes Infinity (which JSON.stringify then serializes as null). Anything that is not
 * a finite number comes back as null so the caller can refuse it.
 */
export function parseAmount(value: string): number | null {
  if (value.trim() === '') {
    return null
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

/**
 * Keystroke filter for numeric boxes: letters and symbols never land (road-test
 * finding on the capacity fields) — but stripping is only allowed to undress a
 * number, never to rewrite one. Whether the survivors form a valid number stays
 * parseAmount's business at submit; the minus survives here on purpose so "-500"
 * is refused as negative downstream instead of silently flipped into valid data.
 */
export function keepDecimal(previous: string, next: string): string {
  // Recognized dressing comes off: grouping commas, whitespace, a leading "$" and
  // a trailing unit ("lb") — joining digits across a comma is what the writer meant.
  const undressed = next
    .replace(/[,\s]/g, '')
    .replace(/^\$/, '')
    .replace(/[a-z]+$/i, '')

  // Anything else would weld digit groups into a different number if stripped —
  // "4O000" into 4000, "1e2" into 12 — so the edit refuses to land instead, and
  // the box visibly keeps what it had (review finding).
  return /^[0-9.-]*$/.test(undressed) ? undressed : previous
}
